<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" >
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

         </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>退货单号:</label>
            <lk-input clearable v-model='query.refundCode' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>销售单号:</label>
            <lk-input clearable v-model='query.orderCode' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>验收人员:</label>
            <lk-input clearable v-model='query.refundInspector' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>退货原因:</label>
            <lk-input clearable v-model='query.refundReason' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap">
          <lk-button class="mr8" type="primary" icon='md-add'  @click="addNew" v-if="showAdd">创建退货单</lk-button>
          <DownloadButton class="mb16" @on-click="downloadExcel" v-if="handlePermission('saleRefundExcel')"></DownloadButton>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
    <LinkQR030 ref="LinkQR030"></LinkQR030>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import afterSale from '../../services/afterSale';
import utils from '../../libs/utils';
import ReturnExpand from './ReturnExpand';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR030 from '../../components/print/LinkQR030';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'saleRefundList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    LinkQR030,
    DownloadButton,
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showPrint: false,
      query: {
        storeIdList: [],
        refundCode: '',
        drugSerialCode: '',
        approvedDrugNames: '',
        goodsName: '',
        refundInspector: '',
        refundReason: '',
        orderCode: '',
      },
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(ReturnExpand,
            {
              props: {
                tableData: row.saleRefundDetailVoList,
              },
            }),
        },
        {
          title: '编号',
          minWidth: 58,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '退货单号',
          minWidth: 116,
          key: 'code',
        },
        {
          title: '退货总金额',
          minWidth: 116,
          key: 'amount',
        },
        {
          title: '退款金额',
          minWidth: 126,
          key: 'proceedsAmountString',
          render: (h, params) => h('span', params.row.proceedsAmountString ? params.row.proceedsAmountString : '-'),
        },
        {
          title: '预收退回金额',
          minWidth: 126,
          key: 'depositAmountString',
          render: (h, params) => h('span', params.row.depositAmountString ? params.row.depositAmountString : '-'),
        },
        {
          title: '状态',
          minWidth: 116,
          key: 'statusName',
        },
        {
          title: '退货日期',
          minWidth: 116,
          key: 'modifiedTimeStr',
        },
        {
          title: '创建人',
          minWidth: 116,
          key: 'createUserName',
        },
        {
          title: '验收记录',
          minWidth: 116,
          key: 'inspectRecord',
        },
        {
          title: '验收人',
          minWidth: 116,
          key: 'refundInspector',
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => {
            let EditDiabled = true;
            let DeleteDisbled = true;
            let PrintDisabled = true;
            const status = row.status;
            if (status === 4) {
              EditDiabled = false;
              DeleteDisbled = false;
            }
            if (status === 3) {
              PrintDisabled = false;
            }
            return h('div', [
              this.showEdit ? h('lk-button',
                {
                  props: {
                    type: 'text',
                    size: 'small',
                    disabled: EditDiabled,
                  },
                  on: {
                    click: () => {
                      this.$router.push(
                        {
                          name: 'saleRefundEdit',
                          params: {
                            id: row.id,
                          },
                        },
                      );
                    },
                  },
                }, '编辑') : null,
              this.showDelete ? h('lk-button',
                {
                  props: {
                    type: 'text',
                    size: 'small',
                    disabled: DeleteDisbled,
                  },
                  on: {
                    click: () => {
                      this.onDelete(row.id);
                    },
                  },
                }, '删除') : null,
              this.showPrint ? h('lk-button',
                {
                  props: {
                    type: 'text',
                    size: 'small',
                    disabled: PrintDisabled,
                  },
                  on: {
                    click: () => {
                      this.$refs.LinkQR030.handlePrint(row.id);
                    },
                  },
                }, '打印') : null,

            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    onDelete(id) {
      const data = {
        saleRefundId: id,
      };
      afterSale.deleteReturn(data).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('删除成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    clear() {
      this.query = {
        storeIdList: [],
        refundCode: '',
        drugSerialCode: '',
        approvedDrugNames: '',
        goodsName: '',
        refundInspector: '',
        refundReason: '',
        nameMix: '',
        orderCode: '',
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      afterSale.returnList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.saleRefund, result);
            result.saleRefundDetailVoList = item.saleRefundDetailVoList;
            result.modifiedTimeStr = result.status === 3 ? utils.formatTime(result.modifiedTime) : '';
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'saleRefundAdd' });
    },
    downloadExcel() {
      const params = Object.assign({}, this.params);
      delete params.page;
      delete params.size;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      afterSale.downloadExcel(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(2, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    if (this.handlePermission('saleRefundAdd')) {
      this.showAdd = true;
    }
    if (this.handlePermission('saleRefundEdit')) {
      this.showEdit = true;
    }
    if (this.handlePermission('saleRefundPrint')) {
      this.showPrint = true;
    }
    if (this.handlePermission('saleRefundDeleteBtn')) {
      this.showDelete = true;
    }
  },
};
</script>
<style lang="less" scoped>
.plan-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  .query-params-wrap{
    padding-bottom: 20px;
  }
  .btn-wrap{
    margin-bottom: 12px;
    >.ivu-btn{
      margin-right: 16px;
    }
  }
}
</style>
